import MockAdapter from 'axios-mock-adapter'

import {mockStore} from '../mockStore'

import {sleepResponse} from './utils'

/**
 * Serves the ConfigCat feature flags for both the `suite` and `hproduce-common` configurations
 * from the burglengenfeld scenario. Both configurations return the same list; `checkFeatureFlag`
 * looks flags up by key so a shared list is sufficient for the mock.
 */
export const enableFeatureFlagsEndpoints = (mock: MockAdapter) => {
  const featureFlagsHandler = () => {
    const {
      burglengenfeld: {featureFlags}
    } = mockStore.scenario()
    return sleepResponse([200, featureFlags])
  }

  mock.onGet(new RegExp('/hproduce-feature-flags/suite/feature-flags$')).reply(featureFlagsHandler)
  mock
    .onGet(new RegExp('/hproduce-feature-flags/hproduce-common/feature-flags$'))
    .reply(featureFlagsHandler)

  return mock
}
